
import { useState } from 'react';
import {
  PhoneCall,
  HelpCircle,
  Send,
  CreditCard,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { dialUssd } from '@/utils/ussd-utils';

export const useToolItems = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [openRechargeDialog, setOpenRechargeDialog] = useState(false);

  const toolItems = [
    {
      id: 'callme',
      title: t('tools.callme.title'),
      description: t('tools.callme.description'),
      icon: <PhoneCall className="h-12 w-12 text-white" />,
      color: '#FF5722',
      action: () => {
        setOpenDialog(true);
      }
    },
    {
      id: 'mynumber',
      title: t('tools.mynumber.title'),
      description: t('tools.mynumber.description'),
      icon: <HelpCircle className="h-12 w-12 text-white" />,
      color: '#2196F3',
      action: () => {
        dialUssd('*123#');
      }
    },
    {
      id: 'recharge',
      title: t('tools.recharge.title'),
      description: t('tools.recharge.description'),
      icon: <CreditCard className="h-12 w-12 text-white" />,
      color: '#FFC107',
      action: () => {
        setOpenRechargeDialog(true);
      }
    }
  ];

  return {
    toolItems,
    openDialog,
    setOpenDialog,
    openRechargeDialog,
    setOpenRechargeDialog
  };
};
